import { render, staticRenderFns } from "./LegalDoc.vue?vue&type=template&id=b11c50ee&scoped=true"
import script from "./LegalDoc.vue?vue&type=script&lang=js"
export * from "./LegalDoc.vue?vue&type=script&lang=js"
import style0 from "./LegalDoc.vue?vue&type=style&index=0&id=b11c50ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11c50ee",
  null
  
)

export default component.exports